import {
  ViewPlugin,
  Decoration,
  type DecorationSet,
  type EditorView,
  type ViewUpdate,
} from '@codemirror/view';
import { RangeSetBuilder } from '@codemirror/state';

const refDecoration = Decoration.mark({ class: 'cm-ref-tag' });
const REF_PATTERN = /@ref\([^)]+\)/g;

function buildDecorations(view: EditorView): DecorationSet {
  const builder = new RangeSetBuilder<Decoration>();
  for (const { from, to } of view.visibleRanges) {
    const text = view.state.doc.sliceString(from, to);
    let match: RegExpExecArray | null;
    REF_PATTERN.lastIndex = 0;
    while ((match = REF_PATTERN.exec(text)) !== null) {
      builder.add(from + match.index, from + match.index + match[0].length, refDecoration);
    }
  }
  return builder.finish();
}

/**
 * CM6 ViewPlugin that decorates @ref(...) markers as inline badges.
 * Uses Decoration.mark() with CSS class "cm-ref-tag" (styled in theme).
 */
export const refHighlightExtension = ViewPlugin.fromClass(
  class {
    decorations: DecorationSet;
    constructor(view: EditorView) {
      this.decorations = buildDecorations(view);
    }
    update(update: ViewUpdate) {
      if (update.docChanged || update.viewportChanged) {
        this.decorations = buildDecorations(update.view);
      }
    }
  },
  { decorations: (v) => v.decorations }
);
